export const TRIGGER = 'trigger';
export const START = 'start';
export const LOG = 'log';
export const SUCCESS = 'success';
export const FAIL = 'fail';
